import { useCallback, useState } from "react";

import { OtpRegisterUIProps } from "./OtpRegister.types";

import { useLoginContext } from "../../views/Login/Login.context.tsx";

export const useOtpRegister = (): OtpRegisterUIProps => {
  const { onOtpRegister } = useLoginContext();

  const [validated, setValidated] = useState(false);
  const [otp, setOtp] = useState("");

  const handleChange = useCallback((value: string) => {
    setOtp(value);
  }, []);

  const handleSubmit = useCallback(
    async (e: React.FormEvent<HTMLFormElement>) => {
      e.preventDefault();
      setValidated(true);

      if (otp.length < 6) return;

      await onOtpRegister(otp);
    },
    [otp, onOtpRegister]
  );

  return {
    otp,
    validated,
    handleChange,
    handleSubmit,
  };
};
